




























































































import Vue from "vue";

// Import Components
import ButtonGroup from "../../../elements/button/ButtonGroup.vue";
import Button from "../../../elements/button/Button.vue";

export default Vue.extend({
  name: "StageSlide",
  props: {
    slide: {
      type: Object,
      required: true
    },
    headline: {
      type: String,
      required: true
    },
    buttonPrimaryText: {
      type: String,
      required: false
    },
    buttonPrimaryFunction: {
      type: Function,
      required: false
    },
    buttonSecondaryText: {
      type: String,
      required: false
    },
    buttonSecondaryFunction: {
      type: Function,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    gradientOverlay: {
      type: Boolean,
      required: false
    }
  },
  inject: {
    components: {
      default: {
        ButtonGroup,
        Button
      }
    }
  }
});
